import React from 'react'

import styles from './index.module.css'

/**
 * Small "BETA" tag matching the badge previously shown next to Search in the
 * sidebar. Text turns white on hover/highlight inside a menu item so it stays
 * readable against the accent-colored highlight background.
 */
const BetaBadge = (): React.ReactNode => (
  <span className={styles.betaBadge}>BETA</span>
)

export default React.memo(BetaBadge)
